<template>
  <div style="width:900px">
    <el-table :data="tableData" border row-key="id" stripe align="left">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="imageUrl" label="书籍封面">
        <template slot-scope="scope">
          <el-image style="width: 50px; height: 50px" :src="scope.row.imageUrl"></el-image>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in col"
        :key="`col_${index}`"
        :prop="item.prop"
        :label="item.label"
        width="200"
      ></el-table-column>
      <el-table-column prop="orgOrder" label="拖拽排序">
        <template>
          <el-button type="primary" icon="el-icon-s-operation"></el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">选择书籍</el-button>
          <el-button type="text" @click="handleRemove(scope.row)" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-bind="dialogOption"
      :view.sync="dialogOption.view"
      :visible.sync="dialogOption.show"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <component :is="dialogOption.view" @close="closeDialog"></component>
    </el-dialog>
  </div>
</template>
<script>
import Sortable from "sortablejs";
import bookSelect from "../components/bookSelect";
import {
  bookList,
  deleteActionRow,
  savePublisher,
  updatPublisher,
  sysUpdate
} from "@/api/sysinfo";
import { Message } from "element-ui";

export default {
  components: { bookSelect },
  data() {
    return {
      col: [
        {
          label: "ISBN号",
          prop: "isbn"
        },
        {
          label: "书籍名称",
          prop: "title"
        }
      ],
      tableData: [],
      dialogOption: {
        title: "选择出版社",
        width: "1200px",
        view: "",
        show: false
      },
      updateRow: {},
      position: 11
    };
  },
  mounted() {
    this.rowDrop();
    // this.columnDrop();
    // 需要请求后台数据，对页面进行初始化
    this.getData();
  },
  methods: {
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currRow);
          let params = [];
          _this.tableData.forEach((item, index) => {
            let data = {
              columnIndex: index,
              linkid: item.linkId
            };
            params.push(data);
          });
          sysUpdate(params, _this.position).then(data => {
            _this.tableData = [];
            _this.getData();
          });
        }
      });
    },
    //列拖拽
    columnDrop() {
      const wrapperTr = document.querySelector(".el-table__header-wrapper tr");
      this.sortable = Sortable.create(wrapperTr, {
        animation: 180,
        delay: 0,
        onEnd: evt => {
          const oldItem = this.dropCol[evt.oldIndex];
          this.dropCol.splice(evt.oldIndex, 1);
          this.dropCol.splice(evt.newIndex, 0, oldItem);
        }
      });
    },
    // 选择出版社
    handleClick(row) {
      this.showDialog("选择书籍", "bookSelect");
    },
    // 删除
    handleRemove(row) {
      if (this.tableData.length === 1) {
        this.$message({
          message: "最后一行数据不能进行删除操作",
          type: "error",
          duration: 5 * 1000
        });
        return;
      }
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            linkId: row.linkId
          };
          deleteActionRow(params).then(data => {
            Message({
              message: "删除成功",
              type: "success",
              duration: 5 * 1000
            });
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 打开对话框
    showDialog(title, view, width = "1200px") {
      this.dialogOption.view = view;
      this.dialogOption.title = title;
      this.dialogOption.show = true;
    },
    closeDialog(val) {
      // 如果有值传进来，则做更新操作
      this.dialogOption.show = false;
      this.dialogOption.view = "";
      this.dialogOption.title = "";
      if (val) {
        this.updateRow = val;
        // console.log(val);
        let params = {
          describes: "书籍销售榜",
          title: val.title,
          lable: val.title,
          isbn: val.isbn,
          position: this.position,
          columnIndex: this.tableData.length + 1,
          imageUrl: val.imageUrl,
          goodsId: val.goodsId,
          linkUrl:
            "proxydf/purch/v2/netmeeting/pb/exhibitionGood/action/byId?goodsId=" +
            val.goodsId,
          rowIndex: val.goodsId
        };
        savePublisher(params).then(data => {
          if (data.data) {
            Message({
              message: "插入成功",
              type: "success",
              duration: 5 * 1000
            });
            this.getData();
          }
        });
      }
    },
    // 查询数据
    getData() {
      let params = {
        position: this.position
      };
      bookList(params).then(data => {
        this.tableData = data.data;
      });
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/sysmanager/ClassifyInfo/BookRank/index.vue